import { useTheme } from '@balance-web/theme';
import type { CSSObject } from '@balance-web/core';

export const useDefaultInteractiveStyles = () => {
  const { semantic } = useTheme();

  const styles: CSSObject = {
    cursor: 'pointer',
    ':hover, :focus, &:focus-visible': {
      background: semantic.colour.neutral.container.interactions.hover,
    },

    ':active': {
      background: semantic.colour.neutral.container.interactions.pressed,
    },
  };

  return styles;
};
